import React from 'react';
import SchedulerComponent from '../../../../Shared/Availability/Availability';
import { guid } from "@progress/kendo-react-common";
import { successToastr, errorToastr, history } from "../../../../../HelperMethods";
import {
    CAND_AVAILABILITY_UPDATED_SUCCESS_MSG,
    CAND_AVAILABILITY_REMOVED_SUCCESS_MSG,
    CAND_AVAILABILITY_CREATED_SUCCESS_MSG,
    AVAILABILITY_ALREADY_EXISTS_CONFIRMATION_MSG
} from "../../../../Shared/AppMessages";
import './ViewAvailability.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import BreadCrumbs from '../../../../Shared/BreadCrumbs/BreadCrumbs';
import { DatePicker, TimePicker } from '@progress/kendo-react-dateinputs';
import { AppPermissions } from '../../../../Shared/Constants/AppPermissions';
import auth from "../../../../Auth";
import globalAdminService from "../../Service/DataService";
import ConfirmationModal from '../../../../Shared/ConfirmationModal';
import { ErrorComponent } from '../../../../ReusableComponents';
import axios from 'axios';

export interface ViewAvailabilityProps {
    props: any;
    match: any;
}

export interface ViewAvailabilityState {
    initialData: any;
    isModalOpen: boolean;
    availability: {
        [key: string]: { enabled: boolean; start: Date; end: Date };
    };
    startDate: Date;
    endDate: Date;
    candidateId: string;
    showAlreadyExistModal: boolean;
    isValidStartDate: boolean;
    isValidEndDate: boolean;
    slotStartDate: Date;
    selectAllCheckBox?: boolean;
    provider?: any;
}

const defaultStart = new Date();
defaultStart.setHours(9, 0, 0, 0);
const defaultEnd = new Date();
defaultEnd.setHours(17, 30, 0, 0);

class ViewAvailability extends React.Component<ViewAvailabilityProps, ViewAvailabilityState> {
    childRef: React.RefObject<SchedulerComponent> = React.createRef();
    overWrite = false;
    generatedEvent: any;

    constructor(props: ViewAvailabilityProps) {
        super(props);
        this.state = {
            initialData: [],
            isModalOpen: false,
            availability: {
                sunday: { enabled: false, start: new Date(defaultStart), end: new Date(defaultEnd) },
                monday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                tuesday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                wednesday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                thursday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                friday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                saturday: { enabled: false, start: new Date(defaultStart), end: new Date(defaultEnd) },
            },
            startDate: new Date(new Date().setDate(new Date().getDate() + 1)),
            endDate: new Date(new Date().setDate(new Date().getDate() + 7)),
            candidateId: "",
            showAlreadyExistModal: false,
            isValidStartDate: true,
            isValidEndDate: true,
            slotStartDate: new Date(new Date().setDate(new Date().getDate() + 1)),
            selectAllCheckBox: false,
            provider: "-"
        };
    }

    componentDidMount() {
        const candidateId = this.props.match.params.id;
        if (candidateId) {
            this.getAllTasks(candidateId);
            this.setState({ candidateId });
            this.getProvider(candidateId);
        }
    }

    async getAllTasks(id: any) {
        globalAdminService.getAllAvailibilityTasks(id).then((res) => {
            this.setState({ initialData: res.data });
        });

    }

    createTask = async (data: any) => {
        const tasks = data.map((event) => {
            const gid = guid();
            return {
                candidateId: this.props.match.params.id,
                slot: JSON.stringify({ ...data[0], id: gid }),
                slotExt: JSON.stringify({
                    ...event, start: event.start.toLocaleString(), end: event.end.toLocaleString(), id: gid
                }),
                startDate: new Date(data[0].start),
            }
        });

        await globalAdminService.createAvailabilityTask(tasks, this.overWrite).then(() => {
            this.getAllTasks(this.props.match.params.id);
            successToastr(CAND_AVAILABILITY_CREATED_SUCCESS_MSG);
        });
    };

    updateTask = (data: any) => {
        const putData = {
            slot: JSON.stringify(data[0]),
            startDate: new Date(data[0].start),
            slotExt: JSON.stringify({ ...data[0], start: data[0].start.toLocaleString(), end: data[0].end.toLocaleString() }),
            candAvalCalId: this.childRef.current?.getScheduleId(data[0].id),
        };

        globalAdminService.updateAvailabilityTask(putData).then(() => {
            this.getAllTasks(this.props.match.params.id);
            successToastr(CAND_AVAILABILITY_UPDATED_SUCCESS_MSG);
        });
    };

    removeTask = (data: any) => {
        const CandAvalCalId = this.childRef.current?.getScheduleId(data[0].id);

        globalAdminService.deleteAvailabilityTask(CandAvalCalId).then(() => {
            this.getAllTasks(this.props.match.params.id);
            successToastr(CAND_AVAILABILITY_REMOVED_SUCCESS_MSG);
        });
    };



    generateTaskSeries = () => {
        const { availability, startDate, endDate } = this.state;
        const events = [];

        const currentDate = new Date(startDate);
        while (currentDate <= endDate) {
            const dayOfWeek = currentDate.toLocaleString('en-US', { weekday: 'long' }).toLowerCase();

            if (availability[dayOfWeek]?.enabled) {
                const start = new Date(currentDate);
                start.setHours(availability[dayOfWeek].start.getHours(), availability[dayOfWeek].start.getMinutes(), 0);

                const end = new Date(currentDate);
                end.setHours(availability[dayOfWeek].end.getHours(), availability[dayOfWeek].end.getMinutes(), 0);

                events.push({
                    start,
                    end,
                    isAllDay: false,
                    title: `Available`,
                    id: `${dayOfWeek}-${currentDate.toDateString()}`
                });
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return events;
    };

    handleSeriesSave = () => {
        if (!this.state.isValidStartDate || !this.state.isValidEndDate) {
            return;
        }
        const events = this.generateTaskSeries();
        this.generatedEvent = events;
        this.createTaskSeries(events);
        this.setState({
            isModalOpen: false,
            startDate: new Date(new Date().setDate(new Date().getDate() + 1)),
            endDate: new Date(new Date().setDate(new Date().getDate() + 7)),
            availability: {
                sunday: { enabled: false, start: new Date(defaultStart), end: new Date(defaultEnd) },
                monday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                tuesday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                wednesday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                thursday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                friday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                saturday: { enabled: false, start: new Date(defaultStart), end: new Date(defaultEnd) },
            },
            selectAllCheckBox: false
        });
    };

    overWriteAvailabilty() {
        this.overWrite = true;
        this.setState({ showAlreadyExistModal: false });
        this.createTaskSeries(this.generatedEvent);
    }
    createTaskSeries = (data: any[]) => {

        const tasks = data.map((event) => {
            const gid = guid();
            return {
                candidateId: this.props.match.params.id,
                slot: JSON.stringify({ ...event, id: gid }),
                slotExt: JSON.stringify({ ...event, start: event.start.toLocaleString(), end: event.end.toLocaleString(), id: gid }),
                startDate: event.start
            }
        });


        globalAdminService.createAvailabilityTask(tasks, this.overWrite)
            .then((response) => {
                const { message, count } = response.data;
                if (response.data == -999) {
                    this.setState({ showAlreadyExistModal: true });
                    this.overWrite = false;
                    return;
                }
                this.overWrite = false;
                successToastr(CAND_AVAILABILITY_CREATED_SUCCESS_MSG);
                this.getAllTasks(this.props.match.params.id);
            })
            .catch((error) => {
                console.error("Error saving tasks:", error);
            });
    };


    toggleDayEnabled = (day: string) => {
        this.setState((prevState) => {
            const updatedDay = !prevState.availability[day].enabled;
            return {
                availability: {
                    ...prevState.availability,
                    [day]: {
                        ...prevState.availability[day],
                        enabled: updatedDay,
                    },
                },
            };
        },
            () => {
                this.setFieldDisable();
                let allDaysEnabled = true;
                for (const key in this.state.availability) {
                    if (this.state.availability[key].enabled === false) {
                        allDaysEnabled = false;
                        break;
                    }
                }
                this.setState({ selectAllCheckBox: allDaysEnabled });
            }
        )
    };

    handleDateChange = (field: 'startDate' | 'endDate', value: Date) => {
        if (value != null) {
            this.setState({ [field]: value } as Pick<ViewAvailabilityState, typeof field>);
        }
    };
    validateDates = (field: 'startDate' | 'endDate') => {
        if (field == "startDate") {
            if (this.state.startDate && (this.state.startDate < this.state.slotStartDate)) {
                this.setState({ isValidStartDate: false });
            }
            else {
                this.setState({ isValidStartDate: true });
                if (this.state.startDate > this.state.endDate) {
                    this.setState({ endDate: this.state.startDate });
                }
            }
        }
        else {
            if (this.state.endDate && (this.state.endDate < this.state.startDate)) {
                this.setState({ isValidEndDate: false });
            }
            else {
                this.setState({ isValidEndDate: true });
            }
        }
    }

    openModal = () => {
        this.setState(
            {
                isModalOpen: true
            },
            this.setFieldDisable
        );
    };

    closeModal = () => {
        this.setState({
            isModalOpen: false,
            startDate: new Date(new Date().setDate(new Date().getDate() + 1)),
            endDate: new Date(new Date().setDate(new Date().getDate() + 7)),
            slotStartDate: new Date(new Date().setDate(new Date().getDate() + 1)),
            availability: {
                sunday: { enabled: false, start: new Date(defaultStart), end: new Date(defaultEnd) },
                monday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                tuesday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                wednesday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                thursday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                friday: { enabled: true, start: new Date(defaultStart), end: new Date(defaultEnd) },
                saturday: { enabled: false, start: new Date(defaultStart), end: new Date(defaultEnd) },
            },
            selectAllCheckBox: false,
        });
    }

    handleTimeChange = (day: string, timeType: 'start' | 'end', value: Date) => {
        if (value != null) {
            this.setState((prevState) => {
                const updatedAvailability = { ...prevState.availability };

                if (timeType === 'start') {
                    updatedAvailability[day].start = value;
                } else if (timeType === 'end') {
                    updatedAvailability[day].end = value;
                }
                return { availability: updatedAvailability };
            });
        }
    };

    handleSlotDoubleClick = (event) => {
        const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        const dayOfTheWeek = days[event.target.props.start.getDay()];
        this.setState(
            {
            startDate: event.target.props.start,
            endDate: event.target.props.start,
            slotStartDate: event.target.props.start,
            availability: Object.keys(this.state.availability).reduce((acc, day) => {
                acc[day] = {
                ...this.state.availability[day],
                enabled: day === dayOfTheWeek
                };
                return acc;
            }, {} as typeof this.state.availability),
            }
        );
        this.openModal();
    }

    setFieldDisable = () => {
        if (document.getElementsByName('startDate')) {
            //TODO: To Be Removed
            // document.getElementsByName('startDate')[0]['disabled'] = true;
            // document.getElementsByName('endDate')[0]['disabled'] = true;
            // document.getElementsByName('startTime')[0]['disabled'] = true;
            // document.getElementsByName('startTime')[1]['disabled'] = true;
            // document.getElementsByName('startTime')[2]['disabled'] = true;
            // document.getElementsByName('startTime')[3]['disabled'] = true;
            // document.getElementsByName('startTime')[4]['disabled'] = true;
            // document.getElementsByName('startTime')[5]['disabled'] = true;
            // document.getElementsByName('startTime')[6]['disabled'] = true;
            // document.getElementsByName('endTime')[0]['disabled'] = true;
            // document.getElementsByName('endTime')[1]['disabled'] = true;
            // document.getElementsByName('endTime')[2]['disabled'] = true;
            // document.getElementsByName('endTime')[3]['disabled'] = true;
            // document.getElementsByName('endTime')[4]['disabled'] = true;
            // document.getElementsByName('endTime')[5]['disabled'] = true;
            // document.getElementsByName('endTime')[6]['disabled'] = true;
        }
    }

    handleSelectAll = () => {
        this.setState((prevState) => {
            const selectAll = !prevState.selectAllCheckBox;
            const updatedAvailability = Object.keys(prevState.availability).reduce((acc, day) => {
                acc[day] = {
                    ...prevState.availability[day],
                    enabled: selectAll,
                };
                return acc;
            }, {});
            return { availability: updatedAvailability, selectAllCheckBox: selectAll };
        });
    }

    getProvider = (id: string) => {
        axios.get(`api/candidates/${id}`).then((res) => {
            this.setState({
                provider: res.data.candidateName ? res.data.candidateName : "-"
            })
        })
    };

    render() {
        const { availability, isModalOpen, startDate, endDate, selectAllCheckBox } = this.state;

        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3  mt-md-0" id="ViewAvailability">
                <div className="col-12">
                    <div className="row pt-2 pb-2 accordianTitleClr mx-auto mb-3 mt-3">
                        <div className="col-10 fonFifteen paddingLeftandRight">
                            <div className="d-none d-md-block">
                                <BreadCrumbs globalData={{ candidateId: this.state.candidateId }}></BreadCrumbs>
                            </div>
                        </div>
                        <div className="col-2">
                            <div className="float-right text-dark">
                                <span className="font-weight-normal">Provider : </span> <span className="mr-1">{this.state.provider}</span>
                            </div>
                            {this.state.candidateId && auth.hasPermissionV2(AppPermissions.CANDIDATE_AVAILABILITY_CREATE) && (
                                <span
                                    className="float-right text-dark cusrsor-pointer"
                                    onClick={this.openModal}
                                >
                                    <FontAwesomeIcon
                                        icon={faPlusCircle}
                                        className={"mr-2 text-dark"}
                                    />
                                    Add Availability
                                </span>
                            )}
                            </div>         
                    </div>
                </div>
                <div className="col-12 mb-4 pb-4">
                    <SchedulerComponent
                        modification={true}
                        selection={false}
                        candidateId={this.props.match.params.id}
                        initialData={this.state.initialData}
                        createTask={this.createTask}
                        updateTask={this.updateTask}
                        removeTask={this.removeTask}
                        ref={this.childRef}
                        defaultDate={new Date()}
                        handleSlotDoubleClick={this.handleSlotDoubleClick}
                    />
                </div>

                <div className="modal-footer justify-content-center border-0">
                    <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                        <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={() => history.goBack()}>
                            <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                        </button>
                    </div>
                </div>
                {isModalOpen && (
                    <div className="containerDialog">
                        <div className="containerDialog-animation">
                            <div className="col-10 col-md-9 col-xxl-7 shadow containerDialoginside containerDialoginside-height px-0">
                                <div className="modal-header rounded-0 bg-blue d-flex justify-content-center align-items-center pt-2 pb-2">
                                    <h4 className="modal-title text-white fontFifteen">
                                        Add Availability
                                    </h4>
                                    <button type="button" className="close text-white close_opacity" data-dismiss="modal" onClick={this.closeModal}>
                                        &times;
                                    </button>
                                </div>
                                <div className="row ml-0 mr-0 mt-2 mb-2 mt-lg-3 mb-lg-3">
                                    <div className="modal-body col-md-12 px-4 px-lg-5">
                                        <div className="mb-0 font-weight-bold mb-3"> <strong className='mb-2 d-block'> Weekly</strong>
                                            <div className="day-row row mx-0 pt-2 px-4 mb-1">
                                                <label className="container-R d-flex mb-0 col-md-2 label-14 d-flex align-items-center"> Select All
                                                    <input
                                                        type="checkbox"
                                                        checked={selectAllCheckBox}
                                                        onChange={() => this.handleSelectAll()}
                                                    />
                                                    <span className="checkmark-R checkPosition checkPositionTop" style={{ left: "0px" }}></span>
                                                </label>
                                            </div>

                                            {['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'].map((day) => (
                                                <div key={day} className="day-row row mx-0 pt-2 px-4 mb-1">
                                                    <label className="container-R d-flex mb-0 col-md-2 label-14 d-flex align-items-center">{day.charAt(0).toUpperCase() + day.slice(1)}
                                                        <input
                                                            type="checkbox"
                                                            checked={availability[day].enabled}
                                                            onChange={() => this.toggleDayEnabled(day)}
                                                        />
                                                        <span className="checkmark-R checkPosition checkPositionTop" style={{ left: "0px" }}></span>
                                                    </label>
                                                    <label className="mb-1 font-weight-bold mr-6 col-md-2 text-right d-flex align-items-center justify-content-end">Start Time :</label>
                                                    <div className="col-md-3">
                                                        <TimePicker
                                                            name='startTime'
                                                            value={availability[day].start}
                                                            onChange={(e) => this.handleTimeChange(day, 'start', e.value)}
                                                            disabled={!availability[day].enabled}
                                                        />
                                                    </div>
                                                    <label className="mb-1 font-weight-bold mr-6 col-md-2 d-flex align-items-center justify-content-end">End Time :</label>
                                                    <div className="col-md-3">
                                                        <TimePicker
                                                            name='endTime'
                                                            value={availability[day].end}
                                                            onChange={(e) => this.handleTimeChange(day, 'end', e.value)}
                                                            disabled={!availability[day].enabled}
                                                            min={new Date(availability[day].start.getTime() + 60 * 1000)}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="mb-0 font-weight-bold mb-3 pt-3"><strong> Date Range </strong>
                                            <div className="mt-2 mx-0 row px-4 pt-2">
                                                <div className="col-md-6" id="ShowDatePickerIcon">
                                                    <div className="row">
                                                        <label className="mb-1 font-weight-bold col-3 no-wrap d-flex align-items-center ">Start Date:</label>
                                                        <div className="col-5">
                                                            <DatePicker
                                                                name='startDate'
                                                                value={startDate}
                                                                format="MM/dd/yyyy"
                                                                onChange={(e) => this.handleDateChange('startDate', e.value)}
                                                                onBlur={(e) => this.validateDates('startDate')}
                                                                min={new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1))}
                                                                max={endDate && new Date(new Date(endDate).setDate(new Date(endDate).getDate() - 1))}
                                                            />
                                                            {!this.state.isValidStartDate && <ErrorComponent message="Please select a valid date" />}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mt-sm-0 mt-2" id="ShowDatePickerIcon">
                                                    <div className="row">
                                                        <label className="mb-1 font-weight-bold col-md-3 no-wrap d-flex align-items-center">End Date:</label>
                                                        <div className="col-5">
                                                            <DatePicker
                                                                name='endDate'
                                                                value={endDate}
                                                                format="MM/dd/yyyy"
                                                                onChange={(e) => this.handleDateChange('endDate', e.value)}
                                                                min={startDate && new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1))}
                                                                onBlur={(e) => this.validateDates('endDate')}
                                                            />
                                                            {!this.state.isValidEndDate && <ErrorComponent message="Please select a valid date" />}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer justify-content-center border-0 mt-3 mb-3">
                                    <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                                        <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={this.closeModal}>
                                            <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                                        </button>
                                        <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={this.handleSeriesSave}>
                                            <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save
                                        </button>
                                        <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={this.handleSeriesSave}>
                                            <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save & Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <ConfirmationModal
                    message={AVAILABILITY_ALREADY_EXISTS_CONFIRMATION_MSG()}
                    showModal={this.state.showAlreadyExistModal}
                    handleYes={() => this.overWriteAvailabilty()}
                    handleNo={() => {
                        this.setState({ showAlreadyExistModal: false });
                    }}
                />
            </div>
        );
    }
}

export default ViewAvailability;